import { WxUnits } from '../utils/wxtools';

export const __units_default_preset: WxUnits = {
	comment1: ["'degC': ['K', 1, 273.15] -> degC = K * 1 + 273.15", 0],
	comment2: ["'hPa': ['Pa', 1000]' -> hPa = Pa * 1000 + 0 (0 - could be ommited)", 0],
	K: ['K', 1],
	kelvin: ['K', 1],
	F: ['K', 0.5555555555, 255.372222222],
	C: ['K', 1, 273.15],
	degC: ['K', 1, 273.15],
	'kg/m^2/s': ['kg/m^2/s', 1],
	'Kg/m^2/s': ['kg/m^2/s', 1],
	'Kg m**-2 s**-1': ['kg/m^2/s', 1],
	'Kg m^-2 s^-1': ['kg/m^2/s', 1],
	'Kg m^{-2} s^-1': ['kg/m^2/s', 1],
	'mm/h': ['kg/m^2/s', 0.00027777777],
	'mm/hr': ['kg/m^2/s', 0.00027777777],
	'W/m^2': ['W/m^2', 1],
	'W m^-2': ['W/m^2', 1],
	'W m^{-2}': ['W/m^2', 1],
	'W/m**2': ['W/m^2', 1],
	'W m**-2': ['W/m^2', 1],
	'm/s': ['m/s', 1],
	'm s**-1': ['m/s', 1],
	'm s^-1': ['m/s', 1],
	'm.s^{-1}': ['m/s', 1],
	knot: ['m/s', 0.514444],
	knots: ['m/s', 0.514444],
	'km/h': ['m/s', 0.27777777777],
	'km h^-1': ['m/s', 0.27777777777],
	'km h**-1': ['m/s', 0.27777777777],
	mph: ['m/s', 0.44704],
	'miles/h': ['m/s', 0.44704],
	s: ['s', 1],
	sec: ['s', 1],
	h: ['s', 3600],
	min: ['s', 60],
	m: ['m', 1],
	cm: ['m', 0.01],
	km: ['m', 1000],
	mile: ['m', 1609.344],
	miles: ['m', 1609.344],
	inch: ['m', 0.0254],
	Pa: ['Pa', 1],
	hPa: ['Pa', 100],
	degree: ['degree', 1],
	radian: ['degree', 57.3],
	'mg/m^3': ['mg/m^3', 1],
	'mg m^-3': ['mg/m^3', 1],
	'mg.m^-3': ['mg/m^3', 1],
	'%': ['%', 1],
	'(0 - 1)': ['%', 100],
};
